/* eslint-disable @typescript-eslint/no-explicit-any */
import PropTypes from 'prop-types';
import ReactDom from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider, useSelector } from 'react-redux';
import { MemoryRouter } from 'react-router';
import Widget from 'src/components/Widget/Widget';
import languages from 'src/locales';
import { setAppMode } from 'src/store/actions/appMode';
import { createClientStore } from 'universal-scripts/lib/redux/store';
import 'src/styles';

declare const __WATCH__: boolean;

const ReduxIntlProvider = ({ children }) => {
	const intl = useSelector((s: any) => s.intl);
	return (
		<IntlProvider key={intl.locale} {...intl}>
			{children}
		</IntlProvider>
	);
};
ReduxIntlProvider.propTypes = {
	children: PropTypes.node
};

class WidgetElement extends HTMLElement {
	constructor() {
		super();
		const widgetConfig = document.getElementById('w-config');
		const client = (widgetConfig as any).getAttribute('client');
		const lang = (widgetConfig as any).getAttribute('lang');
		const locale = lang ?? 'es';
		const shadow = this.attachShadow({ mode: 'open' });
		const baseHost = window?._env_?.HOST_URL || '';
		if (__WATCH__) {
			(window as any).widgetChatbotUpdateStyles = (el) => {
				shadow.appendChild(el);
			};
			if ((window as any).widgetChatbotQueuedStyles) {
				for (const el of (window as any).widgetChatbotQueuedStyles as HTMLElement[]) {
					shadow.appendChild(el);
				}
			}
		} else {
			const css = document.createElement('link');
			css.rel = 'stylesheet';
			css.href = `${baseHost}/widget.css`;
			shadow.appendChild(css);
		}
		const config = document.createElement('script');
		config.src = `${baseHost}/env-config.js`;
		config.defer = true;
		document.head.appendChild(config);
		const outerCss = document.createElement('link');
		outerCss.rel = 'stylesheet';
		outerCss.href = `${baseHost}/fonts/style.css`;
		document.head.appendChild(outerCss);
		const store = createClientStore({
			intl: { locale, messages: languages[locale] }
		});
		store.dispatch(setAppMode('widget'));
		const children = (
			<Provider store={store}>
				<ReduxIntlProvider>
					<MemoryRouter>
						<Widget id={client} />
					</MemoryRouter>
				</ReduxIntlProvider>
			</Provider>
		);
		const root = ReactDom.createRoot(shadow);
		root.render(children);
	}
}

if (!window.customElements.get('widget-chatbot')) {
	window.customElements.define('widget-chatbot', WidgetElement);
}
const w = window.document.createElement('widget-chatbot');
window.document.body.appendChild(w);
